import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import { useDialog } from "@platform/store";
import { MarketingNewsletterDialog, NewsletterFormData } from "./MarketingNewsletterDialog";
import { marketingEventBus } from "@platform/events/marketing.events";

/**
 * Container for MarketingNewsletterDialog.
 * Handles dialog state, API submission, and event tracking.
 */
export function MarketingNewsletterDialogContainer() {
  const { activeDialog, closeDialog } = useDialog();
  const isOpen = activeDialog === "newsletter";

  const submitNewsletter = useMutation({
    mutationFn: async (data: NewsletterFormData) => {
      marketingEventBus.emitEvent("newsletter:submitted", data);

      return await apiRequest(
        "/marketing/contact/",
        "POST",
        {
          first_name: data.firstName || "",
          last_name: data.lastName || "",
          ...data,
          form_type: "newsletter",
        },
        false
      );
    },
    onSuccess: (_data, variables) => {
      marketingEventBus.emitEvent("newsletter:subscribed", variables);
    },
  });

  const handleClose = () => {
    closeDialog();
  };

  return (
    <MarketingNewsletterDialog
      isOpen={isOpen}
      onClose={handleClose}
      onSubmit={submitNewsletter.mutateAsync}
    />
  );
}

